import { z } from 'zod/mini';
import cnh from '~/helpers/cnh';
import formatPrice from '~/helpers/formatPrice';
import useTranslation from '~/hooks/useTranslation';
import priceStatisticStyles from '~/styles/bookingFlow/price-statistic.module.css';
import { SummaryLineSchema } from '~/validation/api/packageSessionResponse';
import PriceStatisticLineItem from './PriceStatisticLineItem';

type Props = {
  className?: string;
  lines: z.infer<typeof SummaryLineSchema>[];
  total: number;
};

export default function PriceStatistic({
  className,
  lines,
  total,
}: Props) {
  const translate = useTranslation();

  return (
    <>
      <ul className={cnh(priceStatisticStyles.lines, className ?? '')}>
        {lines.map((line, lineIndex) => {
          const hasDescription = !!line.description;
          const hasItems = line.items && line.items.length > 0;

          if (line.name.toLowerCase() === 'empty') {
            return null;
          }

          return (
            // eslint-disable-next-line react/no-array-index-key
            <li key={line.type + line.name + line.price + lineIndex}>
              {line.name && (
                <div className={priceStatisticStyles.linesName}>
                  <div>
                    {line.name}
                  </div>

                  <div>
                    {line.price ? formatPrice(line.price) : ''}
                  </div>
                </div>
              )}

              {(hasDescription || hasItems) && (
                <div className={priceStatisticStyles.linesPrice}>
                  {hasDescription && (
                    <div>
                      {line.description}
                    </div>
                  )}

                  {hasItems && line.items && (
                    <div className={priceStatisticStyles.items}>
                      {line.items.map((item, itemIndex) => (
                        <PriceStatisticLineItem
                          // eslint-disable-next-line react/no-array-index-key
                          key={itemIndex}
                          lineItem={item}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
            </li>
          );
        })}
      </ul>

      <div className={priceStatisticStyles.total}>
        {`${translate('bookingFlow.sidebar.total')}**`}

        <div className={priceStatisticStyles.totalPrice}>
          {formatPrice(total)}
        </div>
      </div>
    </>
  );
}
